import React from 'react';
import LoadingButton from '@mui/lab/LoadingButton';

interface ButtonProps {
  label: string;
  color?:
    | 'primary'
    | 'secondary'
    | 'success'
    | 'error'
    | 'info'
    | 'warning'
    | undefined;
  variant: 'text' | 'outlined' | 'contained' | undefined;
  fullWidth?: boolean;
  onClick: any;
  sx?: any;
  href?: string;
  testId?: string;
  autoFocus?: boolean;
  type: 'button' | 'reset' | 'submit';
  size?: 'small' | 'medium' | 'large';
  disabled?: boolean;
  disableElevation?: boolean;
  startIcon?: any;
  endIcon?: any;
  loading?: boolean;
  loadingPosition?: 'start' | 'end' | 'center' | undefined;
}

export function Button({
  label,
  color,
  variant,
  fullWidth,
  onClick,
  testId,
  sx,
  autoFocus,
  type,
  size = 'medium',
  disabled,
  startIcon,
  endIcon,
  href,
  disableElevation,
  loading,
  loadingPosition,
}: ButtonProps) {
  return (
    <LoadingButton
      loading={loading}
      loadingPosition={loadingPosition}
      data-testid={testId}
      type={type}
      autoFocus={autoFocus}
      color={color}
      variant={variant}
      onClick={onClick}
      fullWidth={fullWidth}
      size={size}
      disabled={disabled}
      sx={{ borderRadius: 3, ...sx }}
      startIcon={startIcon}
      endIcon={endIcon}
      href={href}
      disableElevation={disableElevation}
    >
      {label}
    </LoadingButton>
  );
}
